import { Component, OnInit, ViewChild } from '@angular/core';
import { NotificationAlert } from './shared/models/NotificationAlert';
import { Router } from '@angular/router';
import { interval } from 'rxjs';

import { AlertMessages, AlertType } from './core/AlertMessages';
declare var $: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],

})
export class AppComponent implements OnInit {
  @ViewChild('myModal1', { static: true }) myModal1;
  title = 'app';
  ShowSession = false;
  // tslint:disable-next-line: member-ordering
  public static NotArray: NotificationAlert []= [] ;
  public classref = AlertMessages;
  // tslint:disable-next-line: member-ordering
  public static NotInterval = interval(5000);
  // tslint:disable-next-line: member-ordering
  public static IntervalSubscription;
  constructor(private router: Router) { }

  public _headerString: string;
  public _headerMessage: string;
  ngOnInit() {

  }

  updateValue() {
    this.classref.Show('alert', 'message', AlertType.Add);
    this.classref.Show('alert', 'message', AlertType.Error);
    this.classref.Show('alert', 'message', AlertType.Warning);
    this.classref.Show('alert', 'message', AlertType.Success);
  }

}
